export const Log = (...args: any) => {
  window.console.log(...args)
}
export const Err = (...args: any) => {
  window.console.error(...args)
}
export const Warn = (...args: any) => {
  window.console.warn(...args)
}
